import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators,  AbstractControl, ValidationErrors } from '@angular/forms';
import { Subscription } from "rxjs";
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { DatePipe } from '@angular/common';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';

import { moduloRPlus } from '../../diccionarios/RPlusModulo.js';
import { RPlusService } from '../../services/rplus.service';
import { CatalogosIntuiflowService } from '../../catalogos/catalogosIntuiflow.service';
import { MaterialPresentacion, ListMaterialPresentacion } from 'src/app/model/datos-maestros/materialPresentacion';

@Component({
  selector: 'app-configurar-cpd',
  templateUrl: './configurar-cpd.component.html',
  styleUrls: ['./configurar-cpd.component.css']
})

export class ConfigurarCpdComponent implements OnInit {
  public DAT_TITULOS  : any = moduloRPlus.titulos.configurarProcesos;
  public DAT_BTNS     : any = moduloRPlus.button.buttonsNombre;
  public DAT_BTNCSS   : any = moduloRPlus.button.buttonsCss;
  public DAT_AG_GRID  : any = moduloRPlus.agGrid;
  public DAT_MSG      : any = moduloRPlus.mensajes;

  public gridApi      : any;
  public gridColumnApi: any;
  public frameworkComponents: any;
  public columnDefs   : any[] = [];
  public rowData      : any[] = [];

  public isCreate     : boolean = false;
  public tituloModal  : string = '';
  public loading      : boolean = false;

  public FormConfigurar : FormGroup;

  public comboNodos : any[] = [];
  public comboEstado: any[] = [];
  public pipe  = new DatePipe('en-US');

  private subscription = new Subscription();

  constructor(    
    private _util         : UtilsService,
    private rplusService  : RPlusService,
    private fb            : FormBuilder,
    private dmaestrosApi  : DatosMaestrosService,
    private catalogoServive: CatalogosIntuiflowService,
  ) { }

  ngOnInit(): void {

    this.FormConfigurar = this.fb.group({
      paramId       : [''],
      nodo          : ['', [Validators.required]],
      material      : ['', [Validators.required, Validators.pattern(/[0-9]+/), Validators.maxLength(10)]],
      descaMaterial : ['', [Validators.required]],
      unidadBase    : ['', [Validators.required]],
      unidadPT      : [''],
      cpd           : ['', [Validators.required, Validators.pattern(/[0-9]+/)]],
      fechaInicio   : ['', [Validators.required]],
      fechaFin      : ['', [Validators.required]],
      usuario       : ['', [Validators.required]],
      fechaRegistro : ['', [Validators.required]],
      estado        : ['Activo', [Validators.required]],
      fechaUpdate   : [''],
      usuarioUpdate : [''],
    }, 
    {validators: this.fechaValidator}
  );    

    this.FormConfigurar.get('estado').disable();
    this.gridComponent();
    this.inicializarCombos();
    this.obtenerTodo();

    // Suscribirse a cambios
    this.FormConfigurar.get('fechaInicio')?.valueChanges.subscribe(() => {
      console.log("Onchange fecha Inicio");
      this.estatusValidator();
    });

    this.FormConfigurar.get('fechaFin')?.valueChanges.subscribe(() => {
      console.log("Onchange fecha Fin");
      this.estatusValidator();
    });

  }

  // Validador personalizado para fechaFin
  fechaValidator(control: FormGroup): ValidationErrors | null {

    const fechaInicio = control.get('fechaInicio')?.value;
    const fechaFin = control.get('fechaFin')?.value;

    if (fechaInicio && fechaFin) {
      if (new Date(fechaInicio) > new Date(fechaFin)) {
        return { fechaInicioMayor: true };
      }
      if (new Date(fechaFin) < new Date(fechaInicio)) {
        return { fechaFinMenor: true };
      }
    }    
    
    return null;
  }


  estatusValidator() {
    const fechaInicio = this.FormConfigurar.get('fechaInicio')?.value + "T23:59:59";
    const fechaFin = this.FormConfigurar.get('fechaFin')?.value + "T23:59:59";

    let fecha = this._util.getFechayHoraActual();
    const hoy = new Date(fecha);

    if (fechaInicio && fechaFin) {
      console.log("estatusValidator() determinacion de estado por fechas inicio, fin, hoy: ", fechaInicio, fechaFin, hoy );
      //new Date(fechaInicio) <= hoy && 
      if (new Date(fechaFin) >= hoy) {
        this.FormConfigurar.get('estado').setValue("Activo");
      }else{
        this.FormConfigurar.get('estado').setValue("Caducado");
      }
    }  
  }


  gridComponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: 'Ver',
          colorBoton: this.DAT_BTNCSS.info,
        },
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          onClick: this.eliminadoLogico.bind(this),
          label: "Eliminar",
          colorBoton: this.DAT_BTNCSS.danger,
        },
      },
      { field: 'nodo',          sortable: true, filter: true, resizable: true },
      { field: 'material',      sortable: true, filter: true, resizable: true },
      { field: 'descaMaterial', sortable: true, filter: true, resizable: true },
      { field: 'unidadBase',    sortable: true, filter: true, resizable: true },
      { field: 'unidadPT',      sortable: true, filter: true, resizable: true },
      { field: 'cpd',           sortable: true, filter: true, resizable: true },
      { field: 'fechaInicio',   sortable: true, filter: true, resizable: true },
      { field: 'fechaFin',      sortable: true, filter: true, resizable: true },
      { field: 'usuario',       sortable: true, filter: true, resizable: true },
      { field: 'fechaRegistro', sortable: true, filter: true, resizable: true },
      { field: 'estado',        sortable: true, filter: true, resizable: true },
      { field: 'usuarioUpdate', sortable: true, filter: true, resizable: true },
      { field: 'fechaUpdate',   sortable: true, filter: true, resizable: true },
      
    ];
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //params.api.sizeColumnsToFit();
  }

  acciones(event) {
    if (event === 'regresar') return this.closeModal();  
    this.guardar();
  }

  openModal() {
    document.getElementById('abrirModal').click();
  }

  closeModal() {
    document.getElementById('cerrarModal').click();
  }

  inicializarCombos(){
    // Combo de estados
    this.comboEstado = this.catalogoServive.catalogoEstado();

    //Consulta de Nodos
    this.dmaestrosApi.getAllNodos().subscribe(
      (resp) => {
        console.log("resp inicializarCombos{}", resp);
        this.comboNodos = resp;
      },
      (error) => {
        console.log("error inicializarCombos{}", error);
      }
    );
  }

  obtenerTodo() {
    this.loading = true;
    this.rowData = [];

    this.rplusService.getAllParametrosActivos().subscribe(
      (resp)  => { this.rowData = resp; },
      (error) => { console.error("error obtenerTodo{} o vacío", error);}
    );

    this.loading = false;
  }

  nuevo() {
    this.isCreate = true;
    this.tituloModal = this.DAT_TITULOS.tituloAgregar;
    const userData = JSON.parse(localStorage.getItem('datosUsuarioLogin')).login2;
    
    this.FormConfigurar.reset();
    this.FormConfigurar.get("usuario").setValue(userData);
    this.FormConfigurar.get('fechaRegistro').setValue(this._util.getFechayHoraActual());

    this.openModal();
  }

  editar({rowData}) {
    this.isCreate = false;
    this.tituloModal = this.DAT_TITULOS.tituloActualizar;
    
    this.FormConfigurar.reset();
    this.FormConfigurar.patchValue(rowData);
    this.openModal();
  }

  guardar() {
    this.loading = true;
    this.getFormValidationErrors();
    if (this.FormConfigurar.invalid) return;

    const userData = JSON.parse(localStorage.getItem('datosUsuarioLogin')).login2;
    let request = this.FormConfigurar.getRawValue();
    request.material = (request.material || '').trim();
    let mjsUpda = request.nodo + " - " + request.material + " - " + request.cpd;

    if(this.isCreate){ 
      request.fechaRegistro = this._util.getFechayHoraActual();
    }else{
      request.fechaUpdate = this._util.getFechayHoraActual();
      request.usuarioUpdate = userData;
    }

    this._util.confirmarSincronoPromesa({
        title   : this.isCreate ? this.DAT_MSG.mjsProcesar : this.DAT_MSG.actualizar,
        text    : this.isCreate ? "Enviar Nuevo Registro": mjsUpda,
        action  : this.DAT_MSG.datoGuardado,
        funcion : this.isCreate ? this.rplusService.createParametros(request) : this.rplusService.updateParametros(request),
      }).then(() => {
        this.obtenerTodo();
        this.closeModal();
      }).catch(() => {
        this.loading = false;
      });

      this.loading = false;
  }


  eliminadoLogico({rowData}) {
    this.loading = true;
    rowData.estado = 'Eliminado';
    let request = rowData;

    this._util.confirmarSincronoPromesa({
        title   : this.DAT_MSG.eliminar,
        text    : "Esta seguro de elminar el registro actual",
        action  : this.DAT_BTNS.eliminar,
        funcion : this.rplusService.updateParametros(request),
      }).then(() => {
        this.obtenerTodo();
        this.closeModal();
      }).catch(() => {
        this.loading = false;
      });

      this.loading = false;
  }

  onPasteMaterial(event: ClipboardEvent) {
    event.preventDefault();
    const pasted = event.clipboardData?.getData('text') ?? '';
    const clean = pasted.replace(/\s+/g, '');
    const current = this.FormConfigurar.get('material').value || '';
    this.FormConfigurar.get('material').setValue((current + clean).slice(0, 10));
  }

  materialPresentacion : MaterialPresentacion;
  onChangeMaterial(event: any) {
    if (event.key == " " || event.code == "Space" || event.keyCode == 32) return;
    
    this.loading = true;    
    this.FormConfigurar.get('descaMaterial').reset();
    this.FormConfigurar.get('unidadBase').reset();
    this.FormConfigurar.get('unidadPT').reset();

    let codigoMaterial = this.FormConfigurar.get("material").value.trim();

    this.getPresentacionesMaterial(codigoMaterial);
    console.log("List presentaciones::: ", this.listPresentaciones);   

    this.dmaestrosApi.getMaterialxId(codigoMaterial).subscribe(
      (resp) => {
        if (resp) {
          
          this.FormConfigurar.get('descaMaterial').setValue(resp.dscaMaterial);
          this.materialPresentacion = resp.materialPresentacions;
          console.log("Presentación primaria del material[] ", this.materialPresentacion);
          
          let tpsMaterialPermitidos = this.catalogoServive.tiposMaterialesUnidadBase().find(e => e.tipo === resp.tipoMaterial.idTipoMaterial);  
          if (tpsMaterialPermitidos.tipo === resp.tipoMaterial.idTipoMaterial) {
            this.FormConfigurar.get('unidadBase').setValue(resp.unidadMedidaBase);

            if (this.listPresentaciones){
              try {
                this.materialPresentacion = this.listPresentaciones.presentaciones.find(esTerciario => esTerciario.tipoEmpaque.trim() === "TERCIARIO");
                this.FormConfigurar.get('unidadPT').setValue(this.materialPresentacion.idUnidad);
                console.log("Presentacion del material TERCIARIO ", this.materialPresentacion);
              } catch (e) {
                this.FormConfigurar.get('unidadPT').setValue("");
                console.error("Detalle del error::: "+e);
                console.error("No existe presentación TERCIARIO, favor revisar DATASAP.MATERIAL_PRESENTACION");
              }

            } else{
              console.error("No existen presentaciones.Revisar DATASAP.MATERIAL_PRESENTACION");
            }

          }else{
            console.warn("Material "+codigoMaterial+" fuera de Tipos que permite CPD");
            //this.materialPresentacion = this.listPresentaciones.presentaciones.find(sinTipo => sinTipo.tipoEmpaque.trim() === undefined || sinTipo.tipoEmpaque.trim() == null);
            //this.FormConfigurar.get('unidadBase').setValue(this.materialPresentacion[0].idUnidad);
            //console.log(this.materialPresentacion);          
          }
        }

      },(error) => {
        console.error("Error en consultar material onChangeMaterial()");
        this.loading = false;
      }
    );

    this.loading = false;
  }

  public listPresentaciones : ListMaterialPresentacion = new ListMaterialPresentacion();
  getPresentacionesMaterial(idMaterial){
    console.log("getPresentacionesMaterial(), presentaciones para material", idMaterial);

    this.dmaestrosApi.getMaterialPresentacionAllPresentacionesxMaterial(idMaterial).subscribe((resp: MaterialPresentacion[]) => {
        if (resp) {
          this.listPresentaciones.presentaciones.push(...resp);
        }else{
          this._util.alertifyToastWar("No existen valores de presentación para esta material, favor revisar");
        }
      });
  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.FormConfigurar.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.FormConfigurar.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }


  downloadDataCsv() {

    console.log("Reporte de cpd", this.rowData);

    let dataText: any = [];
    let cabecera: any[] = [[
      'paramId',
      'nodo',         
      'material',     
      'descaMaterial',
      'unidadBase',   
      'unidadPT',     
      'cpd',          
      'fechaInicio',  
      'fechaFin',     
      'usuario',      
      'fechaRegistro',
      'estado',       
      'usuarioUpdate',
      'fechaUpdate'
    ]];

    let clonData = this.rowData.map((x) => Object.assign({}, x));
    clonData.forEach((e) => {
      if (!e.isCorrect) {
        dataText.push(
          {
            paramId       : e.paramId,
            nodo          : e.nodo,
            material      : e.material, 
            descaMaterial  : e.descaMaterial, 
            unidadBase    : e.unidadBase, 
            unidadPT      : e.unidadPT, 
            cpd           : e.cpd, 
            fechaInicio   : e.fechaInicio, 
            fechaFin      : e.fechaFin, 
            usuario       : e.usuario, 
            fechaRegistro : e.fechaRegistro,
            estado        : e.estado,
            usuarioUpdate : e.usuarioUpdate, 
            fechaUpdate   : e.fechaUpdate, 
          }
        );
      }
    });  
    
    let name: string = "ListadoNodosCPD.csv";
    this._util.exportCSV(cabecera, dataText, name);
    this._util.mensajeOKToast('El archivo csv se exporto correctame.');
  }

}
